import JoditEditor from "jodit-react";
import { useEffect, useMemo, useRef } from "react";
import "../../src/assets/css/commoncontrol.css";


const RichTextBox = (props) => {
    const richtextref = useRef(null);
    const { field,
        fieldvalue,
        tabIndex = 1,
        textconfig,
        OnChangeofRichBox,
        onBlur,
        setRef
    } = props;

    useEffect(() => {
        if (setRef && richtextref.current) {
            setRef(richtextref)
        }
    }, [setRef])

    // Ensure editor clears when fieldvalue is explicitly set to empty (Fixes Clear button issues)
    useEffect(() => {
        if (richtextref.current && fieldvalue === "") {
            // richtextref.current.value = "";
        }
    }, [fieldvalue]);

    const handleOnChange = async (content) => {
        // To avoid focus out issues, parents should prefer onBlur for state updates.
        // We only call OnChangeofRichBox here if onBlur is NOT provided to prevent focus loss cycles.
        if (OnChangeofRichBox && !onBlur) {
            await OnChangeofRichBox(content)
        }
    }

    const handleOnBlur = async (content) => {
        // Default functionality: always sync latest content on blur.
        // This is the stable way to handle state updates and async functions.
        if (onBlur) {
            await onBlur(content)
        } else if (OnChangeofRichBox) {
            await OnChangeofRichBox(content)
        }
    }

    const config = useMemo(() => ({
        ...textconfig,
        controls: {
            ...textconfig?.controls,
            font: {
                ...textconfig?.controls?.font,
                list: {
                    ...textconfig?.controls?.font?.list,
                    'sans-serif': 'San Serif',
                    'Open Sans': ' Open Sans'
                }
            }
        }
    }), [textconfig]);

    return (
        <JoditEditor
            className='col-12'
            ref={richtextref}
            name={field}
            id={field}
            value={fieldvalue}
            tabIndex={tabIndex}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            config={config}
        />
    );
}
export default RichTextBox;